import {createSlice} from '@reduxjs/toolkit';
import {resetOnboardingState, setIsDeskRequired, setWorkspaceLocation, setParkingLocation} from './actions';
import {OnboardingState} from './types';

const initialState: OnboardingState = {
  floorId: null,
  areaId: null,
  deskAmenities: [],
  parkingLotId: null,
  parkingZoneId: null,
  isDeskRequired: true,
};

export const slice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setWorkspaceLocation, (state, action) => {
      state.floorId = action.payload.floorId;
      state.areaId = action.payload.areaId;
      state.deskAmenities = action.payload.deskAmenities ?? [];
    });
    builder.addCase(setParkingLocation, (state, action) => {
      state.parkingLotId = action.payload.parkingLotId;
      state.parkingZoneId = action.payload.parkingZoneId ?? null;
    });
    builder.addCase(setIsDeskRequired, (state, action) => {
      state.isDeskRequired = action.payload;
    });
    builder.addCase(resetOnboardingState, (state) => {
      state.floorId = initialState.floorId;
      state.areaId = initialState.areaId;
      state.deskAmenities = initialState.deskAmenities;
      state.parkingLotId = initialState.parkingLotId;
      state.parkingZoneId = initialState.parkingZoneId;
      state.isDeskRequired = initialState.isDeskRequired;
    });
  },
});

export const {reducer: onboardingReducer} = slice;
